import * as gsf from "core/src/core/game-state-functions.js";
import { wormColors, SWITCH_ANIM_DURATION } from "core/src/core/constants.js";
import { drawSwitchScene } from "../switch-anim";

// Draws the switcharoonie SWAP animation over the frozen worms during the freeze->go hold.
// Reads gameState.switchAnim = { freezeTime, goTime, assignments }, set by the client on
// switch_freeze/switch_go (and by the host on its own gameState for the debug server view).
// Owner-agnostic: it renders whatever worms are alive and maps each to its new owner, so it
// handles any combination (1<->many, many<->1, many<->many) automatically.
export default function SwitchAnimRenderer({ gameState, players, canvas, canvasState, scale = 1 }) {
    var context = canvas.getContext("2d");
    var prevRenderTime = 0;

    function colorOf(playerId) {
        var pl = players.find(function (p) { return p.id === playerId; });
        return pl ? wormColors[pl.colorId] : "#ffffff";
    }

    function render(renderTime) {
        // Shares the body renderer's per-frame canvas (which owns the clear): skip frames
        // where the clock didn't advance so a paused game doesn't accumulate overdraw.
        if (renderTime === prevRenderTime) return;
        prevRenderTime = renderTime;
        var anim = gameState.switchAnim;
        if (!anim || anim.freezeTime == null) return;
        // The portals open only once the host has confirmed EVERY player is frozen and has named
        // the go moment (switch_go, sent a full animation ahead). Until then: frozen worms, no
        // portals. The animation window is anchored BACKWARDS from go, so it plays out in full and
        // ends exactly as everyone resumes.
        if (anim.goTime == null) return;
        var start = Math.max(anim.freezeTime, anim.goTime - SWITCH_ANIM_DURATION);
        if (renderTime < start || renderTime > anim.goTime) return;
        var p = Math.max(0, Math.min(1, (renderTime - start) / Math.max(0.05, anim.goTime - start)));

        var worms = [];
        var tracks = gameState.wormPathSegments || {};
        for (var id in tracks) {
            if (id.indexOf("#") !== -1) continue; // wall-hack ghost stubs are not worms
            var seg = gsf.getLatestWormPathSegment(gameState, id);
            if (!seg) continue;
            var worm = gsf.getWorm(gameState, seg.wormId);
            if (!worm || !worm.alive) continue;
            // The head is the latest segment's END; during the freeze it's stationary, so this is the
            // frozen head on every view.
            var hx = (seg._wrapNext ? seg._wrapNext.x : seg.endX);
            var hy = (seg._wrapNext ? seg._wrapNext.y : seg.endY);
            worms.push({ x: hx * scale, y: hy * scale, headR: (seg.size || 4) * scale, playerId: worm.playerId });
        }
        if (!worms.length) return;
        // Portals + fireworks roam the whole arena: mark the shared dynamic layer
        // unbounded so next frame's clear wipes it fully (see worm-body-renderer).
        if (canvasState && canvasState.dyn) canvasState.dyn.full = true;
        drawSwitchScene(context, worms, anim.assignments, colorOf, p, renderTime);
    }

    return { render: render };
}
